import { T } from "@tolgee/react";
import { clearSessionAndReload } from "../../utils";

export const CheckEmailExplainerContent = ({
  emailAddress,
}: {
  emailAddress: string;
}) => {
  const handleStartOver = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    clearSessionAndReload();
  };

  return (
    <div className="grid overflow-auto gap-5 place-items-center text-base font-medium text-gray-900">
      <div className="grid gap-[0.3125rem] place-items-center text-center">
        <T keyName="check-email-dialog-auto-saved-progress-text" />
        <br />
        <T keyName="check-email-dialog-email-sent-text" />
        <br />
        <span className="text-display-sm leading-[1.875rem]">
          {emailAddress}
        </span>
      </div>
      <img
        src="/images/check_email_visual.gif"
        alt="Check Email dialog visual"
        className="h-[268px]"
      />
      <div className="grid gap-[0.3125rem] place-items-center">
        <div>
          <T keyName="check-email-dialog-email-not-recieved-text" />{" "}
          <span className="font-semibold">
            <T keyName="check-email-dialog-check-spam-text" />
          </span>
        </div>
        <div className="font-semibold">
          <T keyName="check-email-dialog-wrong-mail-entered-text" />{" "}
          <a href="/" className="underline" onClick={handleStartOver}>
            <T keyName="check-email-dialog-start-over-link-text" />
          </a>
        </div>
      </div>
    </div>
  );
};
